import { Box, Collapse, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as ChevronDownIcon } from 'src/assets/svg/chevron-down.svg';
import { Room } from 'src/shared/types/room';
import { Building } from 'src/shared/types/building';

import { routes } from '../../constants/routes';

import { RoomCard } from './room-card';
import { styles } from './styles';

interface RoomCardMobileOverviewProps {
    roomData: Room;
    building: Building;
    termDuration: number;
    termStartDate: string;
    termEndDate: string;
    numberOfStudents: number;
}
export const RoomCardMobileOverview: FC<RoomCardMobileOverviewProps> = ({
    roomData,
    building,
    termDuration,
    termStartDate,
    termEndDate,
    numberOfStudents,
}) => {
    const navigate = useNavigate();
    const [showRoomInfo, setShowRoomInfo] = useState<boolean>(false);
    const { t } = useTranslation();

    const toggleRoomInfo = () => setShowRoomInfo((prev) => !prev);

    if (!roomData) {
        navigate(routes.failure.index);
        return null;
    }

    return (
        <Box css={styles.mobileRoom}>
            <Box onClick={toggleRoomInfo} css={styles.mobileRoomTitle}>
                <Typography variant="h4" css={styles.roomTitle}>
                    {t('room_card_mobile_name')} {roomData?.room_code}
                </Typography>
                <ChevronDownIcon css={showRoomInfo && styles.roomCardExpanded} />
            </Box>
            <Collapse in={showRoomInfo}>
                <Box css={styles.roomCardWrapper}>
                    <RoomCard
                        roomData={roomData}
                        building={building}
                        termDuration={termDuration}
                        termStartDate={termStartDate}
                        termEndDate={termEndDate}
                        numberOfStudents={numberOfStudents}
                    />
                </Box>
            </Collapse>
        </Box>
    );
};
